<template>
    <router-view :consumer.sync="consumer"></router-view>
</template>
<script>
export default {
    name:"ConsumersRoot",
    data() {
        return {
            consumer:null
        }
    },

    created() {
        this.getApiData();
    },

    methods: {
        async getApiData() {
            await this.$store.dispatch('consumer/get',{
                id: this.$route.params.consumer_id
            }).then((response) => {
                this.consumer = response.consumer
            })
        }
    }
}
</script>
